module.exports = __webpack_public_path__ + "img/01_off.8346b894.png";